import React, { createContext, useContext, useState } from 'react';

const ScientificContext = createContext();

export const ScientificProvider = ({ children }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [selectedIds, setSelectedIds] = useState(new Set());
    const [lastMeshTerms, setLastMeshTerms] = useState([]);

    const clearSearch = () => {
        setSearchQuery('');
        setSearchResults([]);
        setSelectedIds(new Set());
        setLastMeshTerms([]);
    };

    return (
        <ScientificContext.Provider value={{
            searchQuery, setSearchQuery,
            searchResults, setSearchResults,
            selectedIds, setSelectedIds,
            lastMeshTerms, setLastMeshTerms,
            clearSearch
        }}>
            {children}
        </ScientificContext.Provider>
    );
};

export const useScientific = () => {
    const context = useContext(ScientificContext);
    if (!context) {
        throw new Error('useScientific must be used within a ScientificProvider');
    }
    return context;
};
